var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBelarus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9565 11.1304L3.65216 8.76403L4.9565 6.43477L6.26085 8.76403L4.9565 11.1304Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34783 11.1304L1.04349 8.76403L2.34783 6.43477L3.65217 8.76403L2.34783 11.1304Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9565 17.5652L3.65216 15.1988L4.9565 12.8696L6.26085 15.1988L4.9565 17.5652Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34783 17.5652L1.04349 15.1988L2.34783 12.8696L3.65217 15.1988L2.34783 17.5652Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26086 2.32931L5.89158 1.66988C5.22924 2.06231 4.608 2.51667 4.03561 3.02499L4.95652 4.69566L6.26086 2.32931Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9565 19.3043L4.02585 20.9663C4.59772 21.4753 5.21854 21.9304 5.8806 22.3236L6.26089 21.6337L4.9565 19.3043Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30435 15.1305V23.0459C8.74665 23.6598 10.3335 24 12 24C17.1596 24 21.5581 20.7435 23.2536 16.1739L7.30435 15.1305Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2536 16.1739C23.736 14.8739 24 13.4678 24 12C24 5.37263 18.6274 0 12 0C10.3336 0 8.74665 0.339984 7.30435 0.953813V16.1739H23.2536V16.1739Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelarus);
export default __webpack_public_path__ + "static/media/belarus.f9fe7d4af9bfc7e888bdd45cda81e5c1.svg";
export { ForwardRef as ReactComponent };